import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { CampaignNumber } from '@app/models';

export interface CampaignNumberApi {
  items: any[];
  total_count: number;
}

@Injectable({ providedIn: 'root' })
export class CampaignNumberService {

  private API_URL = '/api/campaign-numbers/';
  private headerOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

  private currentCampaignNumberBeingViewed;

  public currentSearch = {
    params: null,
    results: null
  };

  constructor(
    private httpClient: HttpClient
  ) { }


  setCurrentBeingViewed(_campaignNumber: CampaignNumber): void {
    this.currentCampaignNumberBeingViewed = _campaignNumber;
  }


  getCurrentBeingViewed(): CampaignNumber {
    return this.currentCampaignNumberBeingViewed;
  }


  get(_id: string): Observable<CampaignNumber> {
    return this.httpClient.get<CampaignNumber>(this.API_URL + _id);
  }


  getAll(): Observable<CampaignNumber[]> {
    return this.httpClient.get<CampaignNumber[]>(this.API_URL);
  }


  create(_campaignNumber): Observable<CampaignNumber> {
    return this.httpClient.post<CampaignNumber>(this.API_URL, JSON.stringify(_campaignNumber), this.headerOptions);
  }


  update(_campaignNumber: CampaignNumber): Observable<CampaignNumber> {
    return this.httpClient.put<CampaignNumber>(this.API_URL + _campaignNumber._id, JSON.stringify(_campaignNumber), this.headerOptions);
  }


  search(searchTerms): Observable<any[]> {
    searchTerms['selectAll'] = true;
    return this.httpClient.post<any[]>(this.API_URL + 'search', JSON.stringify(searchTerms), this.headerOptions);
  }


  selectAllSearch(searchTerms: CampaignNumber): Observable<CampaignNumber[]> {
    searchTerms['selectAll'] = true;
    return this.httpClient.post<CampaignNumber[]>(this.API_URL + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
  }


  getCustomDatasource(searchParams, sortField = 'number', sortDirection = 'asc', pageNumber: number = 0, pageSize: number = 10): Observable<CampaignNumberApi> {
    searchParams['selectAll'] = false;

    searchParams.sortField = sortField;
    searchParams.sortOrder = sortDirection;
    searchParams.pageNumber = pageNumber;
    searchParams.pageSize = pageSize;

    return this.httpClient.post<CampaignNumberApi>(this.API_URL + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
  }


  deleteByIdArray(arrayOfIds): Observable<any> {
    const deleteRequest = {ids: arrayOfIds};
    return this.httpClient.post<any>(this.API_URL + 'delete-by-array', JSON.stringify(deleteRequest), this.headerOptions);
  }


  delete(_id: string): Observable<any> {
    return this.httpClient.delete(this.API_URL + _id);
  }
}